import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import OrderView from './OrderView';
import './App.css'; // Importamos los estilos

function App() {
  return (
    <Router>
      <div className="app-container">
        <header>
          <h1>Portal de Proveedores - El Gran Surtidor</h1>
        </header>
        <main>
          <Routes>
            {/* La ruta principal que recibe el "token mágico" */}
            <Route path="/orden/:token" element={<OrderView />} />
            {/* Una ruta genérica para enlaces incorrectos */}
            <Route path="*" element={<div className="message-card"><h2>Enlace no válido o la orden ha expirado.</h2></div>} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
